import { ComponentProps, useRef } from "react";
import { MFE, Page, getMFEConfig } from "@sunrun/sales-experience-shared";
import { useIframeMessages } from "./common";
import type { IFrame } from "components/atoms/IFrame";

const useAnalyticsAdapter = (page: Page): ComponentProps<typeof IFrame> => {
  const ref = useRef<HTMLIFrameElement | null>(null);
  const config = getMFEConfig(page as MFE, page as Page);
  const src = `${config.iFrameUrl}`;
  useIframeMessages(ref, "Analytics", config.containerPath);
  return {
    ref,
    basePath: src,
    src,
    title: config.title,
  };
};

export { useAnalyticsAdapter };
